import qs from 'qs';
import ApiResourceManager from '../ApiResourceManager';

export default class PromoCodesManager extends ApiResourceManager {
  get = (params) =>
    this.request({
      method: 'GET',
      url: '/promo-codes',
      params,
      paramsSerializer: qs.stringify,
    });

  show = (id) =>
    this.request({
      method: 'GET',
      url: `/promo-codes/${id}`,
    });

  create = (data) =>
    this.request({
      method: 'POST',
      url: '/promo-codes',
      data,
    });

  update = (id, data) =>
    this.request({
      method: 'PUT',
      url: `/promo-codes/${id}`,
      data,
    });

  delete = (id) =>
    this.request({
      method: 'DELETE',
      url: `/promo-codes/${id}`,
    });

  restore = (id) =>
    this.request({
      method: 'POST',
      url: `/promo-codes/${id}/restore`,
    });

  uploadImage = (id, data) =>
    this.request({
      method: 'POST',
      url: `/promo-codes/${id}/images`,
      data,
    });

  deleteImage = (id, data) =>
    this.request({
      method: 'DELETE',
      url: `/promo-codes/${id}/images`,
      data,
    });

  generateImage = (id) =>
    this.request({
      method: 'POST',
      url: `/promo-codes/${id}/images/generate`,
    });

  getStats = (params) =>
    this.request({
      method: 'GET',
      url: '/promo-codes/stats',
      params,
    });
}
